<div class="layoutBlock">
    <div class="columnFull">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.documents' | hisUi}}"
            [toggleable]="false">
            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.documents.category"
                    styleClass="autocompleteWidth100" [(ngModel)]="documentCategory"
                    [suggestions]="filteredDocumentCategoryValues" [dropdown]="true" [size]="42" [minLength]="1"
                    field="longtext" (completeMethod)="relevantDocumentCategoryValues()" [forceSelection]="true"
                    (ngModelChange)="toggleDocumentUploadButton($event, fileUpload)">
                </p-autoComplete>
            </his-plam>

            <div class="clearAndSpace"></div>
            <p-fileUpload #fileUpload [disabled]="toggleUploadButtonDisabled" mode="advanced"
                chooseLabel="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.documents.upload.chooseFile' | hisUi}}"
                chooseIcon="" [customUpload]="true" [auto]="true"
                (uploadHandler)="customUploadHandler($event, fileUpload)" styleClass="inputWidth100"
                invalidFileLimitMessageSummary="{{'rm.erp.common.documents.uploadFile.invalidFileLimit.summary' | hisUi}} {0}"
                invalidFileLimitMessageDetail="{{'rm.erp.common.documents.uploadFile.invalidFileLimit.detail' | hisUi}} {0}"
                [maxFileSize]="maxFileSize"
                invalidFileSizeMessageSummary="{{'rm.erp.common.documents.uploadFile.invalidFileSize.summary' | hisUi}} {0}"
                invalidFileSizeMessageDetail="{{'rm.erp.common.documents.uploadFile.invalidFileSize.detail' | hisUi}} {0}"
                [accept]="allowedFileExtensions"
                invalidFileTypeMessageSummary="{{'rm.erp.common.documents.uploadFile.invalidFileType.summary' | hisUi}} {0}"
                invalidFileTypeMessageDetail="{{'rm.erp.common.documents.uploadFile.invalidFileType.detail' | hisUi}} {0}">

                <ng-template pTemplate="toolbar">
                    <button (click)="fileUploadHint.toggle($event)" hisImage="information" class="icon"
                        title="Informationen"></button>
                    <p-overlayPanel #fileUploadHint [showCloseIcon]="true" [dismissable]="true">
                        <ng-template pTemplate>
                            <p [innerHTML]="getDocumentUploadHelptext(maxFiles, maxFileSize, allowedFileExtensions)">
                            </p>
                        </ng-template>
                    </p-overlayPanel>
                </ng-template>
                <ng-template pTemplate="content" let-i="index">
                    <div>
                        <span *ngIf="documents.length === 0">
                            {{'rm.erp.common.documents.uploadFile.noFileSelected' | hisUi}}
                        </span>
                        <span *ngIf="documents.length > 0">
                            <p-table [value]="documents" [paginator]="false" [responsive]="true">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>{{'rm.erp.common.documents.upload.filecategory' | hisUi}}</th>
                                        <th>{{'rm.erp.common.documents.upload.filename' | hisUi}}</th>
                                        <th>{{'rm.erp.common.documents.upload.filesize' | hisUi}}</th>
                                        <th>{{'rm.erp.common.documents.upload.actions' | hisUi}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-index="rowIndex" let-document>
                                    <tr>
                                        <td>{{ document.documentCategory?.longtext }}</td>
                                        <td>{{ document.filename }}</td>
                                        <td>{{ document.filesize }}</td>
                                        <td>
                                            <a #downloadLink style="display:none"></a>
                                            <button *ngIf="document.id" (click)="downloadDocument(document)"
                                                hisImage="DOWNLOAD" class="icon"
                                                [title]="'fs.res.common.documents.fileDownload' | hisUi"></button>
                                            <button (click)="removeFile($event, index, fileUpload)" hisImage="delete"
                                                class="icon"
                                                title="{{'rm.erp.common.documents.upload.remove.tooltip' | hisUi}}"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </span>
                    </div>
                </ng-template>
                <div class="clearAndSpace"></div>
                <ng-template pTemplate="file"></ng-template>
            </p-fileUpload>
        </p-panel>
    </div>
</div>